<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>

    <section :id="id" class="social-share mdc-layout-grid__inner center-horizontal">

			 <!-- Share on Twitter -->
			 <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone social-share__tofront">
				 <div class="editable-item__centered">
				 	<a href="https://twitter.com/intent/tweet" class="twitter-share-button" data-size="large" :data-text="text" :data-url="link" data-show-count="false">Post on Twitter</a>
				 </div>
			 </div>

			 <!-- Share on Facebook -->
			 <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone social-share__tofront">
				 <div class="editable-item__centered fb-share-button" :data-href="link" data-layout="button" data-mobile-iframe="false" data-size="large">
					<a class="fb-xfbml-parse-ignore" target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + link">Post on Facebook</a>
				 </div>
			 </div>

	 </section>

</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->

<script>
	export default {
		props: ['link', 'text', 'id'],
		computed: {
			linkEncoded: function() {
				return encodeURIComponent(this.link);
			}
		},
		mounted: function() {
			var div = document.getElementById(this.id);
			if(window.FB) {
				window.FB.XFBML.parse(div);
			}
			if(window.twttr && window.twttr.widgets) {
				window.twttr.widgets.load();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/SocialShare.vue